import * as actionType from "./action";

export function permissionReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_PERMISSION_SUCCESS:
      return { ...state, response };
    case actionType.GET_PERMISSION_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function permissionsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_PERMISSIONS_SUCCESS:
      return { ...state, response };
    case actionType.GET_PERMISSIONS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function rolePermissionReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ROLEPERMISSION_SUCCESS:
      return { ...state, response };
    case actionType.GET_ROLEPERMISSION_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function rolePermissionsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ROLEPERMISSIONS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ROLEPERMISSIONS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function roleReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ROLE_SUCCESS:
      return { ...state, response };
    case actionType.GET_ROLE_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function rolesReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ROLES_SUCCESS:
      return { ...state, response };
    case actionType.GET_ROLES_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
